module.exports = require('./dist/lib/accessible-autocomplete.preact.min')
